import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loadding from "../../components/common/loadding";
import CreateCurriculum from "../../components/curriculum/create/createCurri";
import DeleteCurri from "../../components/curriculum/curriculumDetail/deleteCurri";
import EditCurricurum from "../../components/curriculum/edit/editCruui";
import { Path } from "../../constants/enum/path.emum";
import curriculumService from "../../services/curriculum.service";

const Curriculum = () => {
  const [curri, setCurri] = useState([]);
  const [curriList, setCurriList] = useState([]);
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await curriculumService
        .getAll()
        .then((res) => {
          // console.log(res);
          setCurri(res.data);
          setCurriList(res.data);
          setStatus(false);
        })
        .catch((err) => {
          console.log(err);
        });
    })();
  }, []);

  const handleSearch = (event: any) => {
    setCurriList(
      curri.filter(
        (item: any) =>
          item.name.includes(event.target.value) ||
          item.shortName.includes(event.target.value) ||
          item.type.includes(event.target.value)
      )
    );
  };

  if (status) {
    return <Loadding />;
  }
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">จัดการหลักสูตร</h3>
        <div className="row mt-3">
          <div className="col">
            <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row">
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหาหลักสูตร"
                    aria-label="ค้นหาหลักสูตร"
                    onChange={handleSearch}
                  />
                </div>

                <div className="col-2 d-grid">
                  <CreateCurriculum />
                </div>
              </div>
            </h3>
            <table className="table table-hover table-responsive">
              <thead className="table-dark">
                <tr>
                  <th>รหัสหลักสูตร</th>
                  <th style={{ width: "10%" }}>ชื่อย่อ</th>
                  <th>ชื่อหลักสูตร</th>
                  <th>ระดับ</th>
                  <th style={{ width: "10%" }}>รูปแบบ</th>
                  <th style={{ width: "20%" }}>Handle</th>
                </tr>
              </thead>
              <tbody>
                {!(curriList.length > 0) && (
                  <tr>
                    <td colSpan={4} className="text-danger">
                      <i className="bi bi-folder-x"></i> ไม่พบข้อมูล
                    </td>
                  </tr>
                )}
                {curriList.map((i: any) => {
                  return (
                    <tr key={i.id}>
                      <td scope="row">{i.curriCode}</td>
                      <td scope="row">{i.shortName}</td>
                      <td className="text-start">{i.name}</td>
                      <td>{i.level}</td>
                      <td>{i.UseGE}</td>
                      <td>
                        {/* <LinkContainer to={Path.CURRICULUMS_DETAIL}> */}
                        <Link
                          to={{
                            pathname: `${Path.CURRICULUMS_DETAIL}/${i.id}`,
                          }}
                          type="button"
                          className="btn btn-sm btn-secondary text-white"
                        >
                          <i className="bi bi-pencil-square"></i> รายละเอียด
                        </Link>
                        {/* </LinkContainer> */}
                        <EditCurricurum data={i} />
                        <DeleteCurri curri={i} />
                      </td>
                    </tr>
                  );
                })}
                {/* /////////////////////////////////////////ข้อมูลจำรอง/////////////////////////////////////// */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Curriculum;
